const isProd = () => {
  return process.env.NODE_ENV === 'production' || !!process.env.ORGANIZATION_NAME;
};

const isCanary = () => {
  return process.env.NODE_ENV.includes('canary');
};

const isTest = () => {
  return process.env.IS_TEST;
};

const isDev = () => !isProd();

module.exports = {
  isDev,
  isCanary,
  isProd,
  isTest
};
